import { Navigate, useParams } from "react-router";
import { BrandingEditor } from "@/branding/BrandingEditor";
import { DEFAULT_BRANDING_GROUP, groupForSlug } from "@/branding/groups";

/**
 * Super admin only. Edits the PlatformSettings singleton — the GatiQ default
 * every organization inherits from until it overrides a field (ARCHITECTURE
 * §3.1). Rendered as the Branding tab of `/super-admin/settings`.
 */
export function PlatformBrandingPage() {
  // Read the name rather than hardcoding it: renaming the platform on this
  // very page must also rename the scope this page says it is editing.
  const { group: groupSlug } = useParams();
  const group = groupForSlug(groupSlug);

/**
 * `:group` is user-typed, so an unknown segment must not render an empty
 * editor. It redirects to the first tab rather than 404ing — the person was
 * clearly heading for branding.
 */
  if (!group) {
    return <Navigate replace to={`/super-admin/settings/${DEFAULT_BRANDING_GROUP.slug}`} />;
  }

  return (
    <BrandingEditor activeGroup={group} basePath="/org/branding/platform" mode="platform" />
  );
}
